// Consistent per-manager colors (for charts + the pick-in banner) and per-sector
// colors (for the exposure donut). Hex so Recharts can use them directly.

const MANAGER_PALETTE = [
  "#3b82f6", // blue
  "#16c784", // green
  "#f7c948", // gold
  "#a855f7", // purple
  "#ff7849", // orange
  "#22d3ee", // cyan
];

/** Stable color for a manager by seed (1-indexed) or array index. */
export function managerColor(seedOrIndex: number): string {
  const i = ((seedOrIndex - 1) % MANAGER_PALETTE.length + MANAGER_PALETTE.length) % MANAGER_PALETTE.length;
  return MANAGER_PALETTE[i];
}

const SECTOR_PALETTE = [
  "#3b82f6",
  "#16c784",
  "#f7c948",
  "#a855f7",
  "#ff5c66",
  "#22d3ee",
  "#cbd5e1",
  "#d08b4f",
  "#ec4899",
  "#84cc16",
  "#fb923c",
];

export function sectorColor(index: number): string {
  return SECTOR_PALETTE[((index % SECTOR_PALETTE.length) + SECTOR_PALETTE.length) % SECTOR_PALETTE.length];
}
